@import "../../../../shared/scss/helpers";

:host {
  display: block;

  .spinner {
    display: flex;
    position: relative;
    justify-content: center;
    inline-size: 100%;
    margin-block-start: p-px-to-rem(24px);
  }
}
